export default __webpack_public_path__ + "static/media/tarra-picturemark-d.9c0b9ecf.svg";